@for (option of filteredOptions; track option[field]) {
    <fui-autocomplete-option [field]="field" [key]="key" [option]="option"></fui-autocomplete-option>
}
